export const calculateAmount = (
  values: any,
  setAdditionalFields: any
): void => {
  // Find fixed or per-km income (should be only one)
  const fixedOrPerKm = values?.find(
    (item: any) => item?.incomeType === "fixed" || item?.incomeType === "perkm"
  );

  // Filter other income types
  const otherIncomes = values?.filter(
    (item: any) => item?.incomeType !== "fixed" && item?.incomeType !== "perkm"
  );

  // Early return if no fixed/per-km income found
  if (!fixedOrPerKm) {
    setAdditionalFields({
      sgstAmount: 0,
      cgstAmount: 0,
      totalAmount: 0,
      totalIncomeExclGst: 0,
      balanceAmount: 0,
      fixedOrPerKmIncomeExclGst: 0,
      fixedOrPerKmIncomeInclGst: 0,
      fixedOrPerKmIncomeGst: 0,
    });
    return;
  }

  const { gstPercentage = 0 } = fixedOrPerKm;

  // Calculate fixed or per-km amount with proper validation
  let fixedOrPerKmAmount = 0;
  
  if (fixedOrPerKm?.incomeType === "fixed") {
    // Check if amount is a valid number before calling toFixed
    const amount = Number(fixedOrPerKm?.amount);
    if (!isNaN(amount) && fixedOrPerKm?.amount !== "" && fixedOrPerKm?.amount !== null) {
      fixedOrPerKmAmount = Number(amount.toFixed(2));
    }
  } else if (fixedOrPerKm?.incomeType === "perkm") {
    const amount = Number(fixedOrPerKm?.amount);
    const limit = Number(fixedOrPerKm?.limit) || 0;
    if (!isNaN(amount) && !isNaN(limit) && fixedOrPerKm?.amount !== "" && fixedOrPerKm?.amount !== null) {
      fixedOrPerKmAmount = Number((amount * limit).toFixed(2));
    }
  }

  // Calculate other incomes total
  const otherIncomesAmount = otherIncomes?.reduce(
    (sum: any, income: any) => {
      const amount = Number(income?.amount);
      const isValid = !isNaN(amount);
      return sum + (isValid ? amount : 0);
    },
    0
  );

  // Calculate totals
  const totalIncomeExclGst = fixedOrPerKmAmount + otherIncomesAmount;
  const gstAmount = Number(
    (totalIncomeExclGst * (gstPercentage / 100)).toFixed(2)
  );
  const totalIncomeInclGst = Number(
    (totalIncomeExclGst + gstAmount).toFixed(2)
  );

  // Calculate total payments
  const allPaymentDetails = [
    ...(fixedOrPerKm?.paymentDetails || []),
    ...otherIncomes?.flatMap((item: any) => item?.paymentDetails || []),
  ];

  const totalPayments = allPaymentDetails.reduce(
    (sum: any, payment: any) => {
      const paymentAmount = Number(payment?.paymentAmount);
      return sum + (!isNaN(paymentAmount) ? paymentAmount : 0);
    },
    0
  );

  const balanceAmount = totalIncomeInclGst - totalPayments;

  // Split GST into SGST and CGST (50% each)
  const halfGst = Number((gstAmount / 2).toFixed(2));
  const fixedOrPerKmIncomeGst = Number(
    (fixedOrPerKmAmount * (gstPercentage / 100)).toFixed(2)
  );

  setAdditionalFields({
    sgstAmount: halfGst,
    cgstAmount: halfGst,
    totalAmount: totalIncomeInclGst,
    totalIncomeExclGst,
    balanceAmount,
    fixedOrPerKmIncomeExclGst: fixedOrPerKmAmount,
    fixedOrPerKmIncomeInclGst: Number(
      fixedOrPerKmAmount + fixedOrPerKmIncomeGst
    ),
    fixedOrPerKmIncomeGst,
  });
};
